<template></template>
<script>
export default {
  mounted() {
    this.$store
      .dispatch("asfs/deleteAsf", this.$route.params.id)
      .then(resp => {
        this.$router.push({ name: "asfs" });
        this.$notify({
          type: "success",
          message: this.$t('asf.message.successdelete')
        });
      })
      .catch(error => {
        this.$notify({
          type: "danger",
          message: this.$t('asf.message.errordelete')
        });
      });
  }
};
</script>
<style>
</style>
